module.exports = __webpack_public_path__ + "static/media/smallRocketShip.73899835.png";